import { findTracks } from '../shared'
const data = require('./mock.json')

const tracks = findTracks(data, 'id')

export {
  tracks
}